import { LitElement, html, css, render } from 'lit';
import { search } from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
export class AllInMembersSearch extends AllInOrganisationConsumer(LitElement) {
    static properties = {
        name: { type: String },
        loading: { type: Boolean, state: true },
        restUrl: { type: String },
        nonce: { type: String },
        _members: { type: Array, state: true },
        useSearchInterface: { type: Boolean, state: true },
        hasSearched: { type: Boolean, state: true },
        surname: { type: String, state: true },
        errorMessage: { type: String, state: true },
    };
    constructor() {
        super();
        this._members = [];
        this.loading = false;
        this.hasSearched = false;
        this.useSearchInterface = true;
        this.surname = '';
        this.errorMessage = '';
    }
    async connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        this.eventManager.listen(`allin-search-members-clear-${this.name}`, async (e) => {
            this.searchElement = this.renderRoot.querySelectorAll('input');
            if (this.searchElement.length) {
                this.searchElement.forEach(input => input.value = '');
            }
            this.useSearchInterface = true;
            this.hasSearched = false;
            this._members = [];
            this.errorMessage = '';
        });
    }
    createRenderRoot() {
        return this;
    }
    get input() {
        return this.renderRoot.querySelector('input[name="member_id"]');
    }
    updated(changedProperties) {
    }
    render() {
        let main = html `\n            <div class="allin-members-search-form ${this.loading ? "loading" : ""}" ?aria-busy=${this.loading} >\n                <div class="searchboxes ${this.useSearchInterface ? '' : 'hide'}">\n                    <div class="searchbox">\n                        <label for="allin-members-surname-search">${this.searchByText || `Chwilio am aelod yn \u00F4l cyfenw`}</label>\n                        <input type="text" id="allin-members-surname-search" name="member_surname" @keydown=${(e) => this._handleKeydown(e, 'name')}/>\n                    </div>\n                    <button class="button" ?disabled=${this.loading} @click=${(e) => this._handleSubmit(e, 'name')}>Chwilio</button>\n                    ${this.errorMessage ? html `<div class="error-message">${this.errorMessage}</div>` : ''}\n                </div>\n                <div class="flex space-between wrap ${this.hasSearched && this.useSearchInterface ? '' : 'hide'}" style="max-width: 800px;">\n                    <h4>Methu dod o hyd i\u2019ch aelod?</h4>\n                    <button class="clear" @click=${(e) => this._handleSwitchModes(e)}>Chwilio pob aelod o I Bawb\n                </button></div>\n                <div class="searchboxes ${!this.useSearchInterface ? '' : 'hide'}">\n                    <div class="searchbox">\n                        <label for="allin-members-id-lookup">Rhowch Rif Aelod I Bawb yr aelod.</label>\n                        <input type="text" id="allin-members-id-lookup" name="member_id" aria-required="true" />\n                        <label for="allin-members-surname-lookup">Rhowch gyfenw llawn yr aelod.</label>\n                        <input type="text" id="allin-members-surname-lookup" name="member_surname" aria-required="true" value=${this.surname}/>\n                    </div>\n                    <button class="button" ?disabled=${this.loading} @click=${(e) => this._handleSubmit(e, 'id')}>Chwilio</button>\n                    ${this.errorMessage ? html `<div class="error-message">${this.errorMessage}</div>` : ''}\n                </div>\n            </div>\n        `;
        return html `\n            <input type="hidden" name="member_id">\n            <div class="bg">\n                ${main}\n            </div>\n        `;
    }
    async _handleSubmit(e, type) {
        e.preventDefault();
        this.loading = true;
        this.errorMessage = '';
        let action = type === 'id' ? 'get_member_by_allin_member_number' : 'get_search_members';
        const params = new URLSearchParams();
        if (type === 'id') {
            const idInput = this.renderRoot.querySelector('#allin-members-id-lookup');
            const surnameInput = this.renderRoot.querySelector('#allin-members-surname-lookup');
            const id = idInput?.value?.trim();
            const surname = surnameInput?.value?.trim();
            if (!id || !surname) {
                console.warn('Both ID and surname are required for ID search');
                this.errorMessage = `Mae angen ID a chyfenw i chwilio`;
                this.loading = false;
                return;
            }
            params.append('member_id', id);
            params.append('member_surname', surname);
        }
        else if (type === 'name') {
            const searchInput = this.renderRoot.querySelector('#allin-members-surname-search');
            const search = searchInput?.value?.trim();
            this.surname = search;
            if (!search || search.length < 3) {
                console.warn('Search term must be at least 3 characters');
                this.errorMessage = `Rhaid i'r term chwilio gynnwys o leiaf 3 nod`;
                this.loading = false;
                return;
            }
            params.append('name', search);
            params.append('org_id', this.currentOrg);
        }
        try {
            const response = await fetch(`${this.restUrl}?action=${action}&${params.toString()}`, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            const data = await response.json();
            if (data) {
                if (type === 'id') {
                    if (data.error) {
                        return;
                    }
                    else {
                        this._members = data ? [data] : [];
                    }
                }
                else {
                    this._members = data;
                }
                this.eventManager.emit(`allin-search-results-${this.name}`, { results: this._members, type: type });
            }
        }
        catch (error) {
            console.error('Error fetching members:', error);
        }
        finally {
            this.loading = false;
            this.hasSearched = true;
        }
        this.loading = false;
        // this.organisations = this.dummyorganisations;
    }
    _selectMember(member) {
        this.panel = member.id;
        this._updateContext({ panel: this.panel });
    }
    _handleKeydown(e, type) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this._handleSubmit(e, type);
        }
    }
    _handleClearIDSearch(e) {
        e.preventDefault();
        this.hasIDSearched = false;
        const searchInput = this.renderRoot.querySelector('#allin-members-id-search');
        if (searchInput) {
            searchInput.value = '';
        }
        this.eventManager.emit(`allin-search-members-clear-${this.name}`);
    }
    _handleSwitchModes(e) {
        e.preventDefault();
        this.useSearchInterface = !this.useSearchInterface;
    }
}
